import React from 'react';
import { approach } from '../data/mock';

export default function Approach() {
  return (
    <section className="relative py-20 sm:py-24 lg:py-28 bg-[#0a1b35] overflow-hidden">
      <div className="absolute inset-0 bg-grid opacity-25" />
      <div className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full" style={{ background: 'radial-gradient(circle, rgba(232,184,99,0.07) 0%, transparent 70%)' }} />

      <div className="relative max-w-[1400px] mx-auto px-5 sm:px-6 lg:px-10">
        <div className="max-w-3xl mb-12 sm:mb-16">
          <p className="text-[#e8b863] tracking-[0.28em] text-[11px] font-semibold uppercase mb-5">
            Our approach
          </p>
          <h2 className="font-serif text-white font-medium text-[32px] sm:text-[40px] lg:text-[52px] leading-[1.08] tracking-tight">
            A disciplined methodology,
            <span className="italic gold-gradient"> engineered for outcomes.</span>
          </h2>
          <p className="mt-5 sm:mt-6 text-white/72 text-[15.5px] lg:text-[17px] leading-relaxed">
            Every engagement follows a four-stage process designed to surface the real
            problem, design the right solution, and embed the capability so results endure.
          </p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-12 left-[6%] right-[6%] h-px bg-gradient-to-r from-transparent via-[#e8b863]/30 to-transparent" />
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {approach.map((a, i) => (
              <div key={a.step} className="relative">
                <div className="flex items-center gap-4 mb-5 sm:mb-6">
                  <div className="relative w-14 h-14 rounded-full bg-gradient-to-br from-[#122a52] to-[#1a3a6b] border border-[#e8b863]/35 flex items-center justify-center font-serif text-[#e8b863] text-[20px] font-medium shadow-xl shadow-black/40">
                    {a.step}
                    <span className="absolute inset-0 rounded-full border border-[#e8b863]/15 animate-soft-pulse" />
                  </div>
                  {i < approach.length - 1 && (
                    <div className="hidden lg:block flex-1 h-px bg-gradient-to-r from-[#e8b863]/30 to-transparent" />
                  )}
                </div>
                <h3 className="font-serif text-white text-[24px] sm:text-[26px] font-medium mb-3">{a.title}</h3>
                <p className="text-white/68 text-[14.5px] leading-relaxed">{a.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
